import { supabase } from '../../../lib/api'

export const fetchPenalizacionesByUser = async (userId) => {
    const { data, error } = await supabase
        .from('penalizacion')
        .select('id, fecha_inicio, fecha_final, descripcion_cast, descripcion_cat, estado')
        .eq('id_usuario', userId)

    if (error) {
        console.error('Error al cargar penalizaciones', error)
        return
    }

    const today = new Date()

    const penalizacionesOrdered = data
        .map((penalizacion) => {
            const fechaInicio = new Date(penalizacion.fecha_inicio)
            const fechaFinal = new Date(penalizacion.fecha_final)

            return {
                ...penalizacion,
                fecha_inicio_obj: fechaInicio, // guardamos para no recalcular
                orderStatus:
                    penalizacion.estado === 'Penalizado' && today >= fechaInicio && today <= fechaFinal
                        ? 1
                        : penalizacion.estado === 'Ya penalizado'
                        ? 3
                        : 2,
            }
        })
        .sort((a, b) => {
            if (a.orderStatus !== b.orderStatus) {
                return a.orderStatus - b.orderStatus
            }
            // Si tienen el mismo status, ordena por fecha de inicio descendente
            return b.fecha_inicio_obj - a.fecha_inicio_obj
        })

    return penalizacionesOrdered
}
export const savePenalizacion = async (penalizacion) => {
    const { data: existingPenalizaciones, error: fetchError } = await supabase
        .from('penalizacion')
        .select('id')
        .eq('id_usuario', penalizacion.id_usuario)
        .eq('fecha_inicio', penalizacion.fecha_inicio)
        .eq('descripcion_cast', penalizacion.descripcion_cast)
        .eq('estado', penalizacion.estado)

    if (fetchError || !existingPenalizaciones) {
        console.error('Error al verificar penalizaciones existentes:', fetchError)
        return false
    }

    if (existingPenalizaciones?.length > 0) {
        console.log('Penalización duplicada detectada, no se inserta.')
        return false
    }
    const { data, error } = await supabase.from('penalizacion').insert(penalizacion).select()

    if (error) {
        console.error('Error al guardar la penalización:', error)
        return false
    }

    return data
}

export const updatePenalizacionesToYaPenalizado = async (userId) => {
    const currentDate = new Date().toISOString().slice(0, 10)

    const { error } = await supabase
        .from('penalizacion')
        .update({ estado: 'Ya penalizado' })
        .lt('fecha_final', currentDate)
        .eq('estado', 'Penalizado')
        .eq('id_usuario', userId)

    if (error) {
        console.error('Error al actualizar las penalizaciones:', error)
        return false
    }
    return true
}
